import React from "react";
import { scrollToFilter } from "../../../services/scrollToFilter";
import { DestinationList } from "../destination-list";
import { Modal } from "../../shared/base/modal";
import { SearchSelect } from "../header/search";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";
import TravelExploreOutlinedIcon from "@mui/icons-material/TravelExploreOutlined";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import { useSearchStore } from "../../search/hooks/useSearchStore";

export const BottomBar = () => {
    const [mode, setMode] = React.useState<null | "top" | "search">(null);
        const mobileFormOpen = useSearchStore(state => state.mobileFormOpen);
    
    const onClose = () => {
        setMode(null);
    }

    const sendEvent = (type: "top" | "search" | "whereToGo") => {
        window && window.dataLayer && window.dataLayer.push({
            event: "bottom_bar_click",
            type
        });
    }
    return (
        !mobileFormOpen && (
            <>
                <div className="fixed bottom-0 z-[1000000] flex w-full  justify-center bg-white shadow-top shadow-black/30 md:hidden">
                    <div className=" flex h-[72px] w-full max-w-[600px] flex-row items-stretch justify-around text-center">
                        <div
                            className="flex flex-1 basis-1/3 cursor-pointer flex-col items-center justify-center gap-[4px]"
                            onClick={() => {
                                if (!mode) {
                                    scrollToFilter();
                                    sendEvent("whereToGo");
                                }
                            }}
                        >
                            <TravelExploreOutlinedIcon
                                className={`text-2xl text-sh-red`}
                            />
                            <span className="text-xs font-bold">
                                Where to go
                            </span>
                        </div>
                        <div
                            onClick={() => {
                                mode !== "top" && sendEvent("top");
                                setMode(mode === "top" ? null : "top");
                            }}
                            className={`flex flex-1 basis-1/3 cursor-pointer flex-col items-center justify-center gap-[4px] border-[2px] border-y-0 border-solid border-zinc-200 transition duration-300 ${
                                mode === "top" ? "bg-zinc-100 text-sh-red" : ""
                            }`}
                        >
                            <StarBorderOutlinedIcon className="text-2xl text-sh-red" />
                            <span className="text-xs font-bold">
                                Top destinations
                            </span>
                        </div>
                        <div
                            onClick={() => {
                                mode !== "search" && sendEvent("search");
                                setMode(mode === "search" ? null : "search");
                            }}
                            className={`flex flex-1 basis-1/3 cursor-pointer flex-col items-center justify-center gap-[4px] transition duration-300 ${
                                mode === "search"
                                    ? "bg-zinc-100 text-sh-red"
                                    : ""
                            }`}
                        >
                            <ManageSearchOutlinedIcon
                                className={`text-2xl text-sh-red`}
                            />
                            <span className="text-xs font-bold">
                                Text Search
                            </span>
                        </div>
                    </div>
                </div>
                <Modal active={mode === "top"} onClose={onClose}>
                    <div className="w-full bg-white">
                        <DestinationList />
                    </div>
                </Modal>
                <Modal active={mode === "search"} onClose={onClose}>
                    {/* strange bug, when both React selects are rendered, there are problems with focus */}
                    {mode === "search" && (
                        <div className="w-full bg-white px-8">
                            <div className="h-4"></div>
                            <SearchSelect isMobile={true}></SearchSelect>
                        </div>
                    )}
                </Modal>
            </>
        )
    );
};
